import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a27c8fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-box" }
const _hoisted_2 = { class: "reset" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "reset__title" }, "Error", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "reset__text" }, " Your Token is Wrong or Expired. Try once more. ", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Go to Login ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { direction: "vertical" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_app_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login'))),
            type: "primary",
            class: "w-100 el-button-lg",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}